import * as React from 'react';
import './CookieBanner.scss';
import { childClassClosure, ClassableProps } from "@jcharlesworthuk/your-mum-core/dist/functions";
import { useCookie } from "@use-hook/use-cookie";

export const baseClass = 'cookie-banner';
export const childClass = childClassClosure(baseClass);

type Props = ClassableProps & {
    
}

const CookieBanner: React.FunctionComponent<Props> = () => {
    const [banner, setBanner] = useCookie("banner", "false");
    const onClickAccept = () => {
        setBanner('true');
    }

    if (banner === 'true') return <div className={childClass('hidden')} style={{display: 'none'}}></div>;

    return <div className={baseClass}>
        <p>We use cookies to give you the most relevant experience and improve the service we offer.</p>
        <div className={childClass('controls')}>
            <a className={childClass('link')} href="/cookie-policy">Cookie Policy</a>
            <button className={childClass('button')} onClick={onClickAccept}>Accept</button> 
        </div>
    </div>
}


export default CookieBanner;
